import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidationsService } from '@app/core/services/validations.service';
import { AppConfig } from '@config/app.config';
import { AccountingService } from '@core/services/accounting.service';
import { GeneralsService } from '@core/services/generals.service';
import { Constants } from '@shared/class/constants.class';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-master-transfers-download',
  templateUrl: './master-transfers-download.component.html'
})
export class MasterTransfersDownloadComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public masterForm: FormGroup;
  public minDate = moment().subtract(90, 'days');
  public maxDate = moment();

  constructor(
    public appConfig: AppConfig,
    public accountingService: AccountingService,
    public generalsService: GeneralsService
  ) {}

  ngOnInit() {
    this.masterForm = new FormGroup(
      {
        dateStart: new FormControl('', [
          Validators.required,
          ValidationsService.isDateBetweenNinetyDaysFromToday
        ]),
        dateEnd: new FormControl('', [
          Validators.required,
          ValidationsService.isDateBetweenNinetyDaysFromToday
        ])
      },
      [ValidationsService.validateRangeDateValue]
    );
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.masterForm;
    if (form.dirty && form.valid) {
      const loading = this.generalsService.loading();
      this.accountingService
        .downloadMasterTransfers(form)
        .pipe(takeUntil(this.constants.destroy$))
        .subscribe(
          result => {
            const fileName = this.generalsService.getFileName(
              result.headers.get('content-disposition')
            );
            this.generalsService.download(fileName, 'csv', result);
            loading.close();
          },
          error => {
            loading.close();
            this.generalsService.notification(
              this.appConfig.NOTIFICATION.error,
              this.generalsService.showError(error)
            );
          }
        );
    }
  }
}
